import { __assign } from "tslib";
var filed = ['T', 'GWD-005238', 'trackEvent'];
var opt = {
    1: 'EMP团队组',
    2: '东道新版',
};
var opt1 = {
    1: 'EMP项目组-机票退改',
    2: 'UX新版',
};
var opt2 = {
    1: '产品-机票退改',
    2: '国双新版',
};
export function gspCMSAD(WTCode, open) {
    if (open === void 0) {
        open = true;
    }
    open &&
        window._gsq &&
        window._gsq.push(filed.concat([
            '2021-EMP退改-变更支付完成页面',
            '变更支付完成页面-CMS广告',
            '010-001-71001-003',
            0,
            __assign(__assign({}, opt), { 3: '广告', 6: WTCode }),
        ]));
}
export function gspRecommendFunc(i, open) {
    if (open === void 0) {
        open = true;
    }
    var table = [
        [
            '2021-EMP退改-变更支付完成页面',
            '变更支付完成页面-选择&办登机牌',
            '010-002-71001-103',
            0,
            opt,
        ],
        ['2021-EMP退改-变更支付完成页面', '变更支付完成页面-接送机', '010-003-71001-103', 0, opt],
        ['2021-EMP退改-变更支付完成页面', '变更支付完成页面-代客泊车', '010-004-71001-103', 0, opt],
        ['2021-EMP退改-变更支付完成页面', '变更支付完成页面-贵宾休息室', '010-005-71001-103', 0, opt],
        ['2021-EMP退改-变更支付完成页面', '变更支付完成页面-额外行李', '010-006-71001-103', 0, opt],
        ['2021-EMP退改-变更支付完成页面', '变更支付完成页面-一人多座预售', '010-007-71001-103', 0, opt],
    ];
    open && window._gsq && window._gsq.push(filed.concat(table[i]));
}
export function gspCollect(node, options, open) {
    if (open === void 0) {
        open = true;
    }
    open &&
        window._gsq &&
        window._gsq.push(filed.concat(node).concat([
            0,
            __assign(__assign({}, opt), options),
        ]));
}
export function gspUpgrades(node, options, open) {
    if (open === void 0) {
        open = true;
    }
    open &&
        window._gsq &&
        window._gsq.push(filed.concat(node).concat([
            0,
            __assign(__assign({}, opt1), options),
        ]));
}
// export function gspNewVersion(node, options, open = true) {
//   open &&
//     window._gsq &&
//     window._gsq.push(
//       filed.concat(node).concat([
//         0,
//         {
//           ...opt2,
//           ...options,
//         },
//       ])
//     );
// }
export function gspNewVersion(options, params) {
    try {
        var clickValue = 0; //事件值
        var filed_1 = ["T", "GWD-005238", "trackEvent", "产品-机票退改"];
        window._gsq &&
            window._gsq.push(filed_1.concat(options).concat([clickValue, params]));
    }
    catch (err) {
        console.log("_gsq异常", err);
    }
}



//////////////////
// WEBPACK FOOTER
// ../emp-helpers/dist/es/business/gsp.js
// module id = null
// module chunks = 